/*
 * @Author: LiJunLei 2826904107@qq.com
 * @Date: 2022-12-26 15:15:09
 * @LastEditors: LiJunLei 2826904107@qq.com
 * @LastEditTime: 2023-03-10 16:56:23
 * @FilePath: \emergency-h5\src\api\request\eventCenter\eventReported.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import requests from '@/api/request'
import Cookie from "js-cookie";
let BASE_URL = `api`
let api = {
    add: `${BASE_URL}/emergencyevent/add`,//新增
    update: `${BASE_URL}/emergencyevent/update`,//修改
    judge: `${BASE_URL}/emergencyevent/judge`,//事件研判
    getList:`${BASE_URL}/emergencyevent/pagelist` ,//查询
    details:`${BASE_URL}/emergencyevent/get` ,//详情
    eventPush:`${BASE_URL}/emergencyevent/platform/report` ,//详情
}
// 查询
export async function emergencyeventGetListAPI(data) {
    let obj={
        ...data,
        userId:localStorage.getItem('userId'),
        code:JSON.parse(localStorage.getItem('unitInfo')).strCode,    
        userRoleList:JSON.parse(localStorage.getItem('userRoleLists')),
    }
    return requests({
        url: api.getList,
        method: 'post',
        data:obj,
        headers: {
            token: Cookie.get("tokenAdmin"),
        }
    }
    )
}
// 新增
export async function emergencyeventAddAPI(data) {
    return requests({
        url: api.add,
        method: 'post',
        data,
        headers: {
            token: Cookie.get("tokenAdmin"),
        }
    }
    )
}
// 修改
export async function emergencyeventUpdataAPI(data) {
    return requests({
        url: api.update,
        method: 'post',
        data,
        headers: {
            token: Cookie.get("tokenAdmin"),
        }
    }
    )
}

//事件研判
export async function emergencyeventjudgeAPI(data) {
    return requests({
        url: api.judge,
        method: 'post',
        data,
        headers: {
            token: Cookie.get("tokenAdmin"),
        }
    }
    )
}
// 详情 
export async function emergencyeventDetailsAPI(data) {
    return requests({
        url: api.details,
        method: 'get',
       params: data,
        headers: {
            token: Cookie.get("tokenAdmin"),
        }
    }
    )
}
// 事件推送
// emergencyevent/platform/report
export async function emergencyeventPlatformReportAPI(data) {
    return requests({
        url: api.eventPush,
        method: 'post',
       
       
        data,
        headers: {
            token: Cookie.get("tokenAdmin"),
        }
    }
    )
}